import React, { useEffect, useMemo, useState } from "react"
import { Link } from "gatsby"
import { replaceByDict } from "../utilities/replace-by-dict"
import useQueryParams from "query-params-hook"

const SmartLink = (props) => {
  const { url } = props
  const regex = new RegExp(
    /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?$/gim
  )
  const isExternal = regex.test(url) || url.includes("mailto:")

  const {
    page_version,
    campaign,
    campaign_id,
    adgroup,
    creative,
    taboola_click_id,
    ad_id,
    adset_id,
    campaign_item_id,
    site,
    click_id
  } = useQueryParams();

  const replaceRichLinkHashed = useMemo(
    () => ({
      campaign_name: campaign,
      campaign_id,
      site: site || adgroup || adset_id,
      campaign_item_id:campaign_item_id || creative || adset_id,
      click_id: click_id || taboola_click_id,
      ad_id,
      adset_id: adset_id || adgroup,
    }),
    [
      campaign,
      campaign_id,
      adgroup,
      creative,
      taboola_click_id,
      ad_id,
      adset_id,
    ]
  )

  const [finalUrl, setFinalUrl] = useState();

  useEffect(() => {
    setFinalUrl(!!page_version ? replaceByDict(url, replaceRichLinkHashed) : url)
  }, [page_version, url]);
  
  return isExternal ? (
    <a href={finalUrl} {...props}>
      {props.children}
    </a>
  ) : (
    <Link to={`${!!page_version ? finalUrl : url}/`} {...props}>
      {props.children}
    </Link>
  )
}
export default SmartLink
